import { FC, useEffect, useState, useRef } from 'react';
import { Chart } from 'primereact/chart';
import { format } from 'date-fns';
import { useGetDashboardWidgetsQuery, useGetSalesAchievedQuery, BgSaleAchieved, OgfSaleAchieved, HcSaleAchieved, OgffSaleAchieved, OutletSaleAchieved } from '../generated/graphql';
import { Card } from '../components/dashboard';
import { BiDollar, BiHash } from 'react-icons/bi';
import { currencyFormat } from '../helpers/currencyFormat';

const Dashboard: FC = () => {
  const [labels, setLabels] = useState<string[]>([]);
  const [dataset, setDataset] = useState<string[]>([]);
  const [daily, setDaily] = useState(0);
  const [itemsSold, setItemsSold] = useState<number | undefined>(0);
  const [monthlyAchieved, setMonthlyAchieved] = useState(0);
  const [salesTarget, setSalesTarget] = useState(0);

  const { data: dashboardData } = useGetDashboardWidgetsQuery();

  const { data: achieved } = useGetSalesAchievedQuery({ variables: { input: {} } });
  
  useEffect(() => {
    if (dashboardData?.getDashboardWidgets) {
      setDaily(dashboardData.getDashboardWidgets.todaySales);
      setItemsSold(dashboardData.getDashboardWidgets.todayItemsSold);
      setLabels(dashboardData.getDashboardWidgets.labels);
      setDataset(dashboardData.getDashboardWidgets.data.map(sale => String(sale)));
    }
  }, [dashboardData]);
  
  useEffect(() => {
    const month = Number(format(Date.now(), 'M'));
    const year = Number(format(Date.now(), 'yyyy'));
    let salesAchieved: BgSaleAchieved | OgfSaleAchieved | HcSaleAchieved | OgffSaleAchieved | OutletSaleAchieved | undefined;
    if (achieved?.getSalesAchieved.bgSaleAchieved && achieved?.getSalesAchieved.bgSaleAchieved.length > 0) {
      salesAchieved = achieved?.getSalesAchieved.bgSaleAchieved.find(sale => sale.year === year && sale.month === month);
    } else if(achieved?.getSalesAchieved.ogfSaleAchieved && achieved?.getSalesAchieved.ogfSaleAchieved.length > 0) {
      salesAchieved = achieved?.getSalesAchieved.ogfSaleAchieved!.find(sale => sale.year === year && sale.month === month);
    } else if(achieved?.getSalesAchieved.hcSaleAchieved && achieved?.getSalesAchieved.hcSaleAchieved.length > 0)  {
      salesAchieved = achieved?.getSalesAchieved.hcSaleAchieved!.find(sale => sale.year === year && sale.month === month);
    } else if(achieved?.getSalesAchieved.outletSaleAchieved && achieved?.getSalesAchieved.outletSaleAchieved.length > 0)  {
      salesAchieved = achieved?.getSalesAchieved.outletSaleAchieved!.find(sale => sale.year === year && sale.month === month);
    } else {
      salesAchieved = achieved?.getSalesAchieved.ogffSaleAchieved!.find(sale => sale.year === year && sale.month === month);
    }
    if (salesAchieved) {
      setMonthlyAchieved(salesAchieved.achieved);
      setSalesTarget(salesAchieved.target);
    }
   }, [achieved])

  const chartRef = useRef<any>(null);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Sales Progress',
        labelColor: '#fff',
        backgroundColor: '#09B3EB',
        fill: false,
        data: dataset,
      },
    ],
  }

  const options = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
          ticks: {
              beginAtZero: true
          }
      }]
  }
  };

  const calculateSalesTargetRemaining = () => { 
    const achieved = monthlyAchieved.toFixed(2);
    const remaining = salesTarget - Number(achieved);
    if (remaining <= 0) { 
      return 0;
    } else {
      return remaining;
    }
  }
  
  const doughnutData = {
    labels: ['Achieved', `Target (${currencyFormat(salesTarget)})`,],
    datasets: [
        {
            data: [monthlyAchieved.toFixed(2), calculateSalesTargetRemaining()],
            backgroundColor: ['#50f080', '#f357eb'],
        }
    ]
};

  return <>
      <Chart type="bar" data={chartData} ref={chartRef} options={options} height='450px' />
      <div className="p-d-flex">
        <Card style={{ width: '30%' }} title="Daily Sale" count={String(currencyFormat(daily))} icon={<BiDollar />} />
        <Card style={{ width: '30%' }} title="Daily items sold" count={String(itemsSold)} icon={<BiHash />} />
        <Chart style={{ width: '40%' }} type="pie" data={doughnutData} options={{ maintainAspectRatio: false, }} />
      </div>
  </>
};

export { Dashboard };
